import React, { useEffect, useState } from 'react';
import { format } from 'date-fns';
import apiRoutes from '../../config/apiRoutes';

import AddDocumentBrand from './AddDocumentBrand';
import EditDocumentBrand from './EditDocumentBrand';

//utils
import customAxios from '../../utils/customAxios';
import { resolveError } from '../../utils/resolveError';
import ErrorMessage from '../../utils/ErrorMessage';
import materialTableLocalization from '../../utils/materialTableLocalization';
import PageTitle from '../../utils/PageTitle';

//ui
import MaterialTable from '@material-table/core';
import { Paper } from '@material-ui/core';

type Brands = {
  id: number;
  name: string;
  created_at: Date;
  updated_at: Date;
};

const columns = [
  {
    title: 'id',
    field: 'id',
  },
  {
    title: 'Название',
    field: 'name',
  },
  {
    title: 'Дата обновления',
    field: 'updatedAt',
  },
  {
    title: 'Дата создания',
    field: 'createdAt',
  },
];

const DocumentBrands = () => {
  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<null | string>(null);
  const [editData, setEditData] = useState<null | Brands>(null);
  const [open, setOpen] = useState(false);

  const fetchBrands = async () => {
    try {
      const { data } = await customAxios.get(apiRoutes.BRANDS);
      setBrands(data.data);
    } catch (error) {
      setError(resolveError(error.response));
    } finally {
      setLoading(false);
    }
  };

  const getTransformedData = () => {
    const result = brands?.map((item: Brands) => {
      const modifiedCreatedAt = format(new Date(item?.created_at), 'dd.MM.yyyy');
      const modifiedUpdatedAt = format(new Date(item?.updated_at), 'dd.MM.yyyy');

      return {
        createdAt: modifiedCreatedAt,
        updatedAt: modifiedUpdatedAt,
        ...item,
      };
    });
    return result;
  };

  useEffect(() => {
    fetchBrands();
  }, []);

  return (
    <div className="wrap">
      <PageTitle title="Бренды" />
      <div style={{ textAlign: 'right' }}>
        <AddDocumentBrand fetchBrands={fetchBrands} />
      </div>
      <Paper elevation={4}>
        {error && !loading ? (
          <ErrorMessage error={error} />
        ) : (
          <MaterialTable
            title=""
            isLoading={loading}
            columns={columns}
            data={getTransformedData()}
            actions={[
              {
                icon: 'edit',
                tooltip: 'Редактирование',
                onClick: (event, rowData: any) => {
                  setOpen(true);
                  setEditData(rowData);
                },
              },
            ]}
            options={{
              filtering: true,
              pageSize: 20,
              pageSizeOptions: [20, 50, 100],
              emptyRowsWhenPaging: false,
            }}
            localization={materialTableLocalization}
          />
        )}
      </Paper>
      {open && editData && (
        <EditDocumentBrand
          open={open}
          brandName={editData.name}
          id={editData.id}
          setOpen={setOpen}
          fetchBrands={fetchBrands}
        />
      )}
    </div>
  );
};

export default DocumentBrands;
